export default __webpack_public_path__ + "static/media/warning--steep-ascent--g4.ab1d5bee.png";